import api from './api';

const TENANT = '/agency';

export const recruitmentApi = {
  // Agency side
  get: () => api.get(`${TENANT}/recruitment`),
  update: (data) => api.put(`${TENANT}/recruitment`, data),
  uploadAsset: (kind, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post(`${TENANT}/recruitment/upload/${kind}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  counters: () => api.get(`${TENANT}/recruitment/counters`),
  roster: (status) => api.get(`${TENANT}/roster`, { params: status ? { status } : {} }),
  patchRoster: (talentId, body) => api.patch(`${TENANT}/roster/${talentId}`, body),
  removeFromRoster: (talentId, body) => api.delete(`${TENANT}/roster/${talentId}`, { data: body }),

  // Public
  publicGet: (slug) => api.get(`/public/agency/${slug}`),
  trackVisit: (slug, body) => api.post(`/public/agency/${slug}/track-visit`, body || {}),
  checkEmail: (slug, email) => api.post(`/public/agency/${slug}/check-email`, { email }),
  apply: (slug, body) => api.post(`/public/agency/${slug}/apply`, body),
  existingUserJoin: (slug) => api.post(`/public/agency/${slug}/join`),

  // Talent side
  myAgencies: () => api.get('/talent/my-agencies'),
  leaveAgency: (agencyId, reason) => api.post(`/talent/my-agencies/${agencyId}/leave`, { reason }),
};

export default recruitmentApi;
